import { WPMedia } from '../../types/wordpress';
import { getAttachmentFormat, isPdfAttachment } from '../../utils/resourceAttachments';
import { decodeHtmlEntities } from '../../utils/htmlEntities';

interface AttachmentChipsProps {
  attachments: WPMedia[];
  onPdfClick?: (attachment: WPMedia) => void;
}

export default function AttachmentChips({ attachments, onPdfClick }: AttachmentChipsProps) {
  if (attachments.length === 0) return null;

  const className =
    'inline-flex items-center gap-1 rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 hover:bg-primary/10 hover:text-primary transition-colors';

  return (
    <div className="flex flex-wrap gap-2">
      {attachments.map((attachment) => {
        const { label, icon: Icon } = getAttachmentFormat(attachment);
        const title = decodeHtmlEntities(attachment.title?.rendered) || label;

        if (isPdfAttachment(attachment) && onPdfClick) {
          return (
            <button
              key={attachment.id}
              type="button"
              title={title}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onPdfClick(attachment);
              }}
              className={className}
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </button>
          );
        }

        return (
          <a
            key={attachment.id}
            href={attachment.source_url}
            target="_blank"
            rel="noopener noreferrer"
            title={title}
            onClick={(e) => e.stopPropagation()}
            className={className}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </a>
        );
      })}
    </div>
  );
}
